import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import {observer} from "mobx-react-lite";
import categoryStore from "../store/Category.Store";
import navPathStore from "../store/NavPath.Store";
import http from "../framework/http";
import DOMPurify from 'dompurify';
import {Button} from "antd";

function ModelViewer() {
    const params = useParams();
    const navigate = useNavigate();
    const [model, setModel] = useState();
    const [picture, setPicture] = useState();
    const [modelSelected, setModelSelected] = useState();
    const [price, setPrice] = useState();


    // load navPath for Breadcrumb component
    useEffect(() => {
        if (categoryStore.getCategory()) {
            let categoryItem = categoryStore.getCategory().get(parseInt(params.categoryId));
            if (categoryItem) {
                const newNavPath = [{title: <Link to={"/category/" + categoryItem.id}>{categoryItem.name}</Link>}];
                while (categoryItem.parentId !== 0) {
                    categoryItem = categoryStore.getCategory().get(categoryItem.parentId);
                    newNavPath.unshift({title: <Link to={"/category/" + categoryItem.id}>{categoryItem.name}</Link>})
                }
                newNavPath.unshift({title: <Link to="/" style={{fontWeight: "bold"}}>Home</Link>});
                navPathStore.setNavPath(newNavPath);
            } else {
                navPathStore.setNavPath([]);
            }
        }
    }, [categoryStore.category]);

    useEffect(() => {
        async function loadModel() {
            const res = await http.get("/model/" + params.modelId);
            if (res.data?.code === 200) {
                if (!res.data.data) {
                    navigate("/404");
                    return;
                }
                console.log(res.data.data)
                setModel(res.data.data);
                setPicture(res.data.data.cover);
            }
        }

        loadModel();
    }, [params]);


    const selectedOption = model?.options?.find(o => o.id === modelSelected);
    const calculateSavings = (price) => {
        const originalPrice = parseFloat(price) * 1.05; // 5% markup for display
        const savings = originalPrice - parseFloat(price);
        return {originalPrice, savings};
    };

    return (
        <div className="fonfix-container">
            <div className="fonfix-product-page">
                {/* Left Side - Image */}
                <div className="fonfix-image-section">
                    <div className="fonfix-image-wrapper">
                        <img
                            className="fonfix-product-image"
                            src={picture ? http.getUri() + picture : http.getUri() + "images/default.png"}
                            alt={model?.title}
                        />
                    </div>
                </div>

                {/* Right Side - Product Details */}
                <div className="fonfix-details-section">
                    <h1 className="fonfix-product-title">{model?.title}</h1>

                    {/* Price Display */}
                    {price && (
                        <div className="fonfix-price-wrapper">
                            <div className="fonfix-price-line">
                                {/*<span className="fonfix-price-original">*/}
                                {/*    €{calculateSavings(price).originalPrice.toFixed(2)}*/}
                                {/*</span>*/}
                                <span className="fonfix-price-current">
                                    {selectedOption.name.replace(/\s+/g, '').toLowerCase().includes("waterdamage") && "From "}€{parseFloat(price).toFixed(2)}
                                </span>
                                {/*<span className="fonfix-price-save">*/}
                                {/*    SAVE €{calculateSavings(price).savings.toFixed(2)}*/}
                                {/*</span>*/}
                            </div>
                        </div>
                    )}

                    {/* Options Selection */}
                    {model?.options && model.options.length > 0 && (
                        <div className="fonfix-options-wrapper">
                            <div className="fonfix-options-header">
                                <span className="fonfix-options-label">CHOOSE FAULT:</span>
                                <span className="fonfix-options-selected">
                                    {selectedOption ? selectedOption.name.toUpperCase() : 'SELECT AN OPTION'}
                                </span>
                            </div>

                            <div className="fonfix-options-list">
                                {model.options.map(option => (
                                    <div
                                        key={option.id}
                                        className={`fonfix-option-item ${modelSelected === option.id ? 'active' : ''}`}
                                        onClick={() => {
                                            if (option.id === modelSelected) {
                                                setModelSelected(undefined);
                                                setPrice(undefined);
                                                setPicture(model.cover);
                                            } else {
                                                setModelSelected(option.id);
                                                setPrice(option.price);
                                                setPicture(option.picture ? option.picture : model.cover);
                                            }
                                        }}
                                    >
                                        <div className="fonfix-option-radio">
                                            {modelSelected === option.id &&
                                                <div className="fonfix-option-radio-dot"></div>}
                                        </div>
                                        <span className="fonfix-option-name">{option.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* CTA Button */}
                    <div className="fonfix-cta-wrapper">
                        <Button
                            className="fonfix-book-btn"
                            disabled={!modelSelected}
                            onClick={() => {
                                if (modelSelected) {
                                    const message = model.title + " ---- " + model.options.find(o => o.id === modelSelected).name;
                                    navigate("/contactUs/" + encodeURIComponent(message));
                                } else {
                                    navigate("/contactUs");
                                }
                            }}
                        >
                            CONTACT US
                        </Button>
                    </div>

                    {/* Description Section - Inside Second Column */}
                    {model?.description && (
                        <div className="fonfix-description-inline">
                            <div className="fonfix-tabs-section">
                                <div className="fonfix-tab active">Description</div>
                            </div>
                            <div className="fonfix-description-wrapper">
                                <div
                                    className="fonfix-description-content"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(model.description)
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default observer(ModelViewer);
